import {Component, EventEmitter, Output} from '@angular/core';
import {FormsModule} from "@angular/forms";
import {Store} from "@ngrx/store";
import {ActivatedRoute, Router} from "@angular/router";
import {FilesService} from "../../services/files/files.service";
import {DoWhenReadyService, Readyables} from "../../services/do-when-ready.service";
import {SearchService} from "../../services/search.service";
import {User} from "../../auth/primitives/user";
import {cameraActions} from "../../state/camera/camera.actions";
import {Vector3} from "three";
import {ProfileImageComponent} from "../profile-image/profile-image.component";
import {IconsService} from "../../services/icons.service";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";

@Component({
  selector: 'toolbar-profile-search',
  standalone: true,
  imports: [
    FormsModule,
    ProfileImageComponent,
    FaIconComponent
  ],
  templateUrl: './toolbar-profile-search.component.html',
  styleUrl: './toolbar-profile-search.component.scss'
})
export class ToolbarProfileSearchComponent {

  oldSearchText = "";
  searchText = "";
  profileActive = false

  user: User = null
  profileBase64: string

  @Output() profileClicked = new EventEmitter();

  constructor(
      private store: Store,
      private router: Router,
      private route: ActivatedRoute,
      private fileService: FilesService,
      private doWhenReady: DoWhenReadyService,
      private searchService: SearchService,
      public iconService: IconsService
  ) {
    this.doWhenReady.firstTime(this, [Readyables.network], async (user: User)=> {
      this.user = user
      const serverFile = await this.fileService.getFile(this.user.profile_image_file_id)
      this.profileBase64 = serverFile.fileData
    })
  }

  async searchKeyPressed(event: string) {
    if (event.length > 0) {
      this.setSearchActive(true)
    } else {
      this.setSearchActive(false)
    }
    this.searchService.searchTerm.next(event)
  }

  enterPressed(input) {
    const text = this.searchText;
    if (this.isCoordinate(text)) return;
  }


  setSearchActive(enabled: boolean) {
    if (enabled) {
      this.searchText = this.oldSearchText;
      this.router.navigate([{outlets: {'right-pane': "search"}}])
    }
    if (!enabled) {
      this.searchText = "";
      this.oldSearchText = this.searchText;
      // this.router.navigate([{outlets: {'right-pane': null }}]);
    }
  }


  setProfileActive() {
    this.profileClicked.emit()
    // console.log(this.profileActive)
    // this.profileActive = !this.profileActive
    // if (this.profileActive) {
    //   this.router.navigate([{outlets: {'right-pane': "profile"}}])
    // } else {
    //   this.router.navigate([{outlets: {'right-pane': null}}])
    // }
  }


  isCoordinate(input) {
    const matches = input.match(/([+-]?\d+)::?([+-]?\d+)(?:::?([+-]?\d+))?/);
    if (matches) {
      const coordx = matches[1];
      const coordy = matches[2];
      const coordz = matches[3];
      this.gotoLocation(coordx, coordy, coordz);
      return true;
    }
    return false;
  }

  gotoLocation(x: string, y: string, z: string) {
    this.store.dispatch(
        cameraActions.targetJumped({
          target: new Vector3(parseInt(x), parseInt(y), parseInt(z)),
        }),
    );
  }
}
